<template>
  <HeaderMenu
    info
    :title="$t('case_creation.risk')"
    :value="value"
    :expanded="null"
    :options="options"
    @click:info="toggleRiskScoreModal"
    @input="selectRiskLabel"
    :dropdown="checkPermission('caseRiskScore.update_case_risk_label')"
  >
    <template #after>
      <ModalConfirm
        v-if="checkPermission"
        ref="addRiskConfirm"
        :disabled="!manualRiskLabel.trim()"
      >
        <template #content>
          <FormulateInput
            class="w-full"
            :label="$t('case_creation.provide_note')"
            :placeholder="$t('case_creation.provide_note')"
            type="text"
            validation="required"
            :element-class="
              (context, classes) => ['flex-1 min-w-full'].concat(classes)
            "
            v-model="manualRiskLabel"
          />
        </template>
      </ModalConfirm>

      <CaseScoreBreakdown
        v-if="caseEntityList.length > 1"
        :caseTypeEntityId="caseEntity?.id"
        :caseEntities="caseEntityList"
      />
    </template>
  </HeaderMenu>
</template>

<script>
// ! Is dependent on Vuex data

import { mapGetters, mapActions } from "vuex";
import ModalConfirm from "@shared/modal-confirm";
import { HeaderMenu } from "./";
import {
  CaseScoreBreakdown,
} from "@shared/case-creation/CaseCreationFlow/components";

import {
  checkPermission,
} from "@shared/utils/functions";

import { caseEntityTypesMap } from "@shared/modules/localization/utils/caseEntityTranslation/constants";
import { translateEntity } from "@shared/modules/localization/utils/caseEntityTranslation";

export default {
  components: {
    ModalConfirm,
    HeaderMenu,
    CaseScoreBreakdown,
  },
  props: {
    case_id: {
      type: String,
      required: true,
    },
    caseEntityList: {
      type: Array,
      default: () => [],
    },
    caseEntity: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      manualRiskLabel: "",
    }
  },
  computed: {
    ...mapGetters({
      getRiskScoreData: "CaseCreationStore/getRiskScoreData",
      getRiskLabelOptions: "CaseCreationStore/getRiskLabelOptions",
    }),

    value() {
      const value = translateEntity(this.getRiskScoreData, caseEntityTypesMap.RISK)
      return {
        value: value?.label_id || "",
        label: value?.label_name || "",
        color: value?.label_color || "",
        tLabel: value.label,
        tLetter: value.letter,
        type: 'score',
      }
    },
    options() {
      return this.getRiskLabelOptions.map((el) => {
        const _el = translateEntity(el, caseEntityTypesMap.RISK)
        return ({
          value: _el.id,
          label: _el.description,
          color: _el.color,
					tLabel: _el.label,
					tLetter: _el.letter,
        })
      })
    }
  },
  methods: {
    ...mapActions({
        fetchRiskScore: "CaseCreationStore/fetchRiskScore",
        fetchRiskLabelOptions: "CaseCreationStore/fetchRiskLabelOptions",
        setRiskLabel: "CaseCreationStore/setRiskLabel",
        toggleRiskScoreModal: "CaseCreationStore/toggleRiskScoreModal",
    }),

    checkPermission,

    async selectRiskLabel(option) {
      try {
        this.setManualRiskLabel();
        const confirmed = await this.$refs.addRiskConfirm.show({
          title: this.$t('case_creation.override_risk'),
          autoclose: false,
        });

        const reason = this.manualRiskLabel.trim();

        if (confirmed && reason) {
          const payload = {
            label_id: option.value,
            case_id: this.case_id,
            reason,
          }
          await this.setRiskLabel(payload);
          // refetch risk score after manual label is stored to update displayed value
          await this.fetchRiskLabelOptions({ case_id: this.case_id });

          await this.fetchRiskScore({ case_id: this.case_id });

          this.$toast.success(this.$t('case_creation.success_case_risk_update'));
        }
        this.$refs.addRiskConfirm.close();
      } catch (error) {
        this.$toast.error(this.$t('case_creation.success_case_risk_update'));
        console.error("Failed to set the risk label", error);
      }
    },

    setManualRiskLabel(payload = "") {
      this.manualRiskLabel = payload;
    },
  }
}
</script>

<style lang="scss" scoped>

</style>